import React, { useEffect } from 'react';
import './TimedDialog.scss';

const TimedDialog = ({ open, onClose, title, description, children, duration = 3000 }) => {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [open, onClose, duration]);

  if (!open) {
    return null;
  }

  return (
    <div className="timed-dialog-overlay">
      <div className="timed-dialog">
        <button onClick={onClose} className="close-button">X</button>
        <h2 className="timed-dialog-title">{title}</h2>
        <div className="timed-dialog-message">{children || description}</div>
      </div>
    </div>
  );
};

export default TimedDialog;